import {FC} from 'react';

import {
  transactionColumns,
  TransactionTypeFilter,
  useGetAllTransactions,
  withUserColumn,
} from '@entities/transaction';
import {MrTable} from '@shared/components';
import {FilterRow, SelectFilter} from '@shared/components/filters';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';

import {PaginationState} from '@/shared/types';

const localStorageKey = 'orderTransactionsTable';

const typeFilterOptions = [
  {value: null, label: 'Type'},
  {value: TransactionTypeFilter.credit, label: 'Credit'},
  {value: TransactionTypeFilter.debit, label: 'Debit'},
  {value: TransactionTypeFilter.coins, label: 'Coins'},
];

const columns = withUserColumn(transactionColumns);

type UrlState = PaginationState & {
  filter: TransactionTypeFilter | null;
};

interface Props {
  orderId: string;
}

export const OrderTransactionsTab: FC<Props> = ({orderId}) => {
  const {urlState, setUrl} = useUrlState<UrlState>({
    pageIndex: 0,
    pageSize: 10,
    filter: null,
  });

  const {data, isFetching, error} = useGetAllTransactions({
    page: urlState.pageIndex + 1,
    pageSize: urlState.pageSize,
    filter: urlState.filter ?? TransactionTypeFilter.all,
    relatedEntityId: orderId,
  });

  return (
    <MrTable
      columns={columns}
      data={data?.items ?? []}
      error={error}
      renderTopToolbarCustomActions={() => (
        <FilterRow>
          <SelectFilter
            value={urlState.filter}
            onChange={filter =>
              setUrl(prev => ({...prev, pageIndex: 0, filter}))
            }
            options={typeFilterOptions}
          />
        </FilterRow>
      )}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      /////////////////////////////
      // pagination + state
      enablePagination
      manualPagination
      onPaginationChange={updater =>
        setUrl(prev => ({
          ...prev,
          ...(typeof updater === 'function' ? updater(prev) : updater),
        }))
      }
      rowCount={data?.total ?? 0}
      /////////////////////////////
      state={{
        isLoading: isFetching,
        pagination: {
          pageIndex: urlState.pageIndex,
          pageSize: urlState.pageSize,
        },
      }}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
